import { UpdateContactInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const updateContactMutationAtom = createMutationAtomFactory(
  'crm.contactUpdate',
  (contact: UpdateContactInput) => ({
    crmContactUpdate: {
      __args: {
        id: contact.id as string,
        input: contact,
      },
      id: true,
    },
  }),
);
